import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

interface SectionProps {
  header?: ReactNode;
  /** Small hint under the section. */
  footer?: ReactNode;
  children?: ReactNode;
  /** Render children without the white grouped background (e.g. a post preview). */
  bare?: boolean;
  className?: string;
}

/** Inset grouped list on a secondary background (docs/UI.md 2, spacing and shape). */
export function Section({ header, footer, children, bare, className }: SectionProps) {
  return (
    <section className={cx('mx-4 mb-8', className)}>
      {header && (
        <h2 className="mb-2 px-4 text-[13px] uppercase tracking-wide text-section-header">
          {header}
        </h2>
      )}
      {children &&
        (bare ? children : <div className="overflow-hidden rounded-xl bg-section">{children}</div>)}
      {footer && <p className="mt-2 px-4 text-[13px] leading-normal text-hint">{footer}</p>}
    </section>
  );
}
